import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { inject, Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from 'rxjs/operators';
import { AuthService } from "../../auth.service";
import { EnvService } from "@gea-waldviertler-website/shop-lib";

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  authService: AuthService
  private envService = inject(EnvService)

  constructor(
    @Inject(AuthService) authService: AuthService
  ) {
    this.authService = authService
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add auth header on gea-api requests only
    if (! (request.url.startsWith(this.envService.config.apiURL) || (request.url.startsWith(this.envService.config.apiURL_SSR)))) return next.handle(request)
    if (request.url.includes("/customer/validate_email")) return next.handle(request)

    const user = this.authService.user()

    return next.handle(request).pipe(tap(
      event => event instanceof HttpResponse ? 'succeeded' : '',
      error => {
        if (error.status == 401 && user) {
          this.authService.clear()
          this.authService.showAccountModal("Deine Anmeldung ist abgelaufen. Bitte melde dich erneut an.")
        }
      }
    ))
  }
}
